import React from 'react';
import Youtube from 'react-youtube';
import { Typography } from 'amphitheatre';
import { DesktopVid } from '../Tutorials.styled';

import TutorialPage from '../TutorialPage';

const { Paragraph } = Typography;

const opts = {
  height: '100%',
  width: '100%',
};

const Video1: React.FunctionComponent = () => {
  return (
    <TutorialPage title="Video #3: Overpasses and Scenes">
      <Paragraph>
        <i>
          These videos were made on the old version of P.I.G.I. However, these
          are still applicable to the current version.
        </i>
      </Paragraph>
      <DesktopVid>
        <Youtube
          containerClassName="video-container"
          videoId="d68_G4fXA54"
          opts={opts}
        />
      </DesktopVid>
    </TutorialPage>
  );
};

export default Video1;
